<template>
  <div class="newhand">
    <!-- 文案 -->
    <div class="warper clearfix">
      <div class="breadcrumbBox">
              <!-- 面包屑 -->
              <a-breadcrumb>
                <a-breadcrumb-item>
                <i class="iconfont icon-menu-home" style="color: #2b6afd;margin-right:5px"></i>
                  <a href="/help" style="color: #2b6afd"
                    >帮助中心</a
                  ></a-breadcrumb-item
                >
                <a-breadcrumb-item>
                  <a href="/help/release" style="color: #2b6afd">发布说明</a>
                </a-breadcrumb-item>
                <a-breadcrumb-item>
                  <span style="color: #2b6afd"> {{articleTitle}}</span>
                </a-breadcrumb-item>
              </a-breadcrumb>
            </div>
        <ArticleContent :id="articleId" @setarticleTitle="setarticleTitle"/>
        <div style="width: 80%">
          <a-row type="flex" justify="space-between">
            <a-col
              ><span
                class="pointer"
                v-if="Previous.id"
                @click="goUrl(Previous)"
              >
                上一篇：{{ Previous.name }}</span
              ></a-col
            >
            <a-col
              ><span class="pointer" v-if="Next.id" @click="goUrl(Next)"
                >下一篇：{{ Next.name }}</span
              >
            </a-col>
          </a-row>
        </div>
    </div>
  </div>
</template>
<script>
import ArticleContent from "@/views/ArticleContent.vue";
import { categories2 } from "@/utils/query.js";

export default {
  components: {
    ArticleContent,
  },
  data() {
    return {
      articleId: "",
      articleTitle: "",
      Previous: {},
      Next: {},
    };
  },
  mounted() {
    this.articleId = this.$route.query.id;
    this.getCate();
  },
  activated(){
    this.articleId = this.$route.query.id;
    this.getCate();
  },
  methods: {
    goUrl(item) {
      this.$router.push({
        name: "releaseArticle",
        query: { id: item.id },
      });
      this.articleId = item.id;
      this.getCate();
    },
    setarticleTitle(value){
      this.articleTitle = value
    },
    async getCate() {
      let res = await categories2();
      if (res.success) {
        let list = res.data.directoryJson.filter((item, index, self) => {
          return item.name == "发布说明";
        });
        this.List = list[0].children.reverse();
        this.Previous = {};
        this.Next = {};
        for (let index = 0; index < this.List.length; index++) {
          if (this.articleId == this.List[index].id) {
            // console.log("index", index + 1);
            if (index - 1 >= 0) {
              this.Previous = this.List[index - 1];
            }
            if (index + 1 < this.List.length) {
              this.Next = this.List[index + 1];
            }
          }
        }
      }
    },
  },
};
</script>
<style scoped>
::v-deep .ant-breadcrumb-separator {
  color: #2b6afd;
}
/* newhand */
.newhand {
  min-height: 100vh;
  padding-top: 68px;
  position: relative;
}
.ListBox {
  margin: 1rem 0;
}
.pointer {
  cursor: pointer;
  padding: 0 0.5rem;
}
.breadcrumbBox {
  padding: 1rem;
}
.breadcrumbBox::v-deep .ant-breadcrumb > span:last-child {
  color: rgba(0, 0, 0, 0.45);
}
</style>
